// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import config from '../../config/config';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const leaderProfileRecognitionAPI = createApi({
  reducerPath: 'leaderProfileRecognitionAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ['Recognitions'],
  endpoints: (builder) => ({
    getRecognitionData: builder.query<any, leaderProfileRecognitionArgTypes>({
      query: ({ affiliateCode, aboNumber }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/profile/recognition`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { affiliateCode, aboNumber }) => [
        { type: 'Recognitions', id: `${affiliateCode}-${aboNumber}` },
      ],
    }),
    createRecognition: builder.mutation<any, leaderProfileRecognitionArgTypes>({
      query: ({ affiliateCode, aboNumber, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/profile/recognition`,
        method: 'POST',
        data: payload,
      }),
      invalidatesTags: (_result, _error, { affiliateCode, aboNumber }) => [
        { type: 'Recognitions', id: `${affiliateCode}-${aboNumber}` },
      ],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetRecognitionDataQuery, useCreateRecognitionMutation } =
  leaderProfileRecognitionAPI;
